import { createFileRoute } from "@tanstack/react-router";
import UsSportsPredictions from "@/pages/UsSportsPredictions";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findUsSport } from "@/lib/oddsSports";

export const Route = createFileRoute("/{$sport}-predictions/")({
  head: ({ params }) => {
    const sport = findUsSport(params.sport);
    return {
      meta: socialMeta({
        seo: { topics: [params.sport, "predictions"] },
        title: sport?.title ?? `${readable(params.sport)} Predictions | Statlign`,
        description:
          sport?.description ??
          "Model predictions, odds and value edges with the reasoning shown for every pick.",
        ...(sport ? { image: `https://statlign.com/og-${sport.slug}.jpg` } : {}),
      }),
    };
  },
  component: () => (
    <MainLayout>
      <UsSportsPredictions />
    </MainLayout>
  ),
});
